import ContactPlaceholder from '$tablet-app/src/app/components/Contact/ContactPlaceholder';
import Spacer from '$tablet-app/src/app/components/Spacer';
import Text from '$tablet-app/src/app/components/Text';
import { hasImage } from '$tablet-app/src/app/images/actions';
import RecordImage from '$tablet-app/src/app/images/components/RecordImage';
import { UserModel } from '@akin-home/user';
import React, { FC } from 'react';
import styled from 'styled-components/native';

interface Props {
  user: UserModel;

  onPress?: (user: UserModel) => void;
}

const SwitchProfileMemberItem: FC<Props> = (props) => {
  const { user, onPress } = props;

  const showImage = hasImage(user);

  const handlePress = () => onPress?.(user);

  return (
    <Container onPress={handlePress}>
      {showImage ? (
        <UserImage record={user} />
      ) : (
        <Placeholder height={86} width={86} initial={user?.name?.[0] || 'U'} />
      )}

      <Spacer height="16px" />

      <NameText weight="semibold">{user.name}</NameText>
    </Container>
  );
};

const Container = styled.TouchableOpacity`
  align-items: center;
`;

const Placeholder = styled(ContactPlaceholder)`
  height: 86px;
  width: 86px;

  border-radius: 30px;

  background-color: #acbbff;
`;

const UserImage = styled(RecordImage)`
  height: 86px;
  width: 86px;

  border-radius: 30px;
`;

const NameText = styled(Text)`
  color: #f8ffff;
`;

export default SwitchProfileMemberItem;
